const PLACEHOLDER_CLIENT_IDS = new Set([
  '',
  'YOUR_GOOGLE_CLIENT_ID',
  'YOUR_GOOGLE_CLIENT_ID_HERE',
  'your-google-client-id.apps.googleusercontent.com',
]);

export const googleClientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();

export const isGoogleOAuthConfigured = !PLACEHOLDER_CLIENT_IDS.has(googleClientId);
